<template>
  <div class="filters-additional">
    <button
        class="vcv-button gray iconed"
        v-tooltip.top-center="$tr('responses.additionalFilters.label')"
        @click="showFilters"
      >
        <i class="fa fa-sliders"/>
      </button>
  </div> 
</template>

<script>
  import FilterPanelAdditional from '@/components/responses/FilterPanelAdditional.vue'

  export default {
    extends: FilterPanelAdditional,

    methods: {
      showFilters () {
        this.$store.dispatch('process/shlumberger/modals/filterPanelAdditional/show')
      }
    }
  }
</script>

<style lang="scss" scoped>
  .filters-additional {
    display: flex;
    order: 1;
  }
</style>
